import React, { useMemo } from 'react';
import Pressable from 'components/Pressable';
import { getButtonColors } from './utils';
import { Container } from './styled';
const ButtonOly = (props) => {
    const { appearance = 'primary', borderRadius = '4px', fullWidth = false, isDisabled = false, isLoading = false, size = 'small', title, icon, onClick, marginRight, justifyContent, testId, color, } = props;
    const buttonColors = useMemo(() => {
        return getButtonColors(appearance);
    }, [appearance]);
    const { customColor, customHoverColor, customTextColor } = buttonColors;
    return (React.createElement(Container, { marginRight: marginRight, isDisabled: isDisabled, justifyContent: justifyContent, "data-testid": testId },
        React.createElement(Pressable, { customColor: color || customColor, customHoverColor: color || customHoverColor, customTextColor: customTextColor, fullWidth: fullWidth, icon: icon, isDisabled: isDisabled, loading: isLoading, onPress: onClick, size: size, title: title, borderRadius: borderRadius, wrapperStyle: { width: fullWidth ? '100%' : 'auto' } })));
};
export default ButtonOly;
